import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import ProductDropdown from "./ProductDropdown";
import "../css/CustomNavbar.css"; // Ensure CSS is updated
interface CustomNavbarProps {
  isExpanded: boolean;
  toggleMenu:any;
}

const CustomNavbar: React.FC<CustomNavbarProps> = ({isExpanded,toggleMenu}) => {


  return (
    <>
      {/* Toggler placed OUTSIDE Navbar */}
      {/* <button className="custom-toggler" onClick={toggleNavbar}>
        <span className="navbar-toggler-icon"></span>
      </button> */}

      <Navbar expand="lg" className="custom-navbar" expanded={isExpanded} sticky="top">
        <Container>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#/" className="custom-nav-link">Home</Nav.Link>
              <ProductDropdown  toggleMenu={toggleMenu}/>
              <Nav.Link href="#/aboutus" className="custom-nav-link">About Us</Nav.Link>          
              <Nav.Link href="#/contactus" className="custom-nav-link">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default CustomNavbar;
